<div class="flex-row gap-10">

  <app-place-selector class="top-bar-site"
    (placeEditEvent)="onPlaceSectionClick($event)"
  [iconColor]="iconColor"></app-place-selector>

  @if (isLoading) {
    <mat-divider [vertical]="true"></mat-divider>
    <app-delivery-date-selector [isLoading]="true"
    [iconColor]="iconColor"></app-delivery-date-selector>
  } @else {
    @if (orderingIsOpen && displayDeliveryDatePicker) {
      <mat-divider [vertical]="true"></mat-divider>
      <app-delivery-date-selector [deliveryDate]="deliveryDate"
        (deliveryDateChange)="onDeliveryDateChange($event)"
      [iconColor]="iconColor"></app-delivery-date-selector>
    }
  }

</div>
